import React from 'react'
import CapsuleArrowHome from '../../atoms/SvgIcons/CapsuleArrowHome'
import Button from '../../atoms/Button/Button'
import Constants from '../../../app/utils/constants'
import { trackClarityEvent } from "../../../app/utils/ClarityAnalytics";
import { trackEvent } from "../../../app/utils/firebaseEvents";
import { CLARITY_EVENTS } from "../../../app/utils/EventTypes";

const { capsules } = Constants

const HomeBannerComponent = () => {
  const handleviewOurWork = () => {
    const payloadViewWork = {
      source: 'banner_home',
    }

    trackClarityEvent(CLARITY_EVENTS.VIEW_OUR_WORK, payloadViewWork)
    trackEvent(CLARITY_EVENTS.VIEW_OUR_WORK, payloadViewWork)
    window.location.href = '/portfolio'
  }

  const handlestartyourproject = () => {
    const payloadStartProject = {
      source: 'banner_home',
    }

    trackClarityEvent(CLARITY_EVENTS.START_YOUR_PROJECT, payloadStartProject)
    trackEvent(CLARITY_EVENTS.START_YOUR_PROJECT, payloadStartProject)
    window.location.href = '/contactus'
  }

  return (
        <div className="relative flex flex-col xl:pt-25 items-center justify-center xl:pb-16 z-999 min-h-[600px] md:min-h-[70vh] bg-home bg-no-repeat bg-contain bg-center">
            <style>
                {`
                    @keyframes capsuleFloat {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-10px); }
                    }

                    @keyframes capsuleGlimmer {
                        0%, 100% { filter: brightness(1); }
                        50% { filter: brightness(1.2); }
                    }
                `}
            </style>
            <div className="w-full h-full relative z-40 flex flex-col  justify-between items-center">
                <div></div>
                <div className="text-white text-3xl md:text-7xl text-center leading-[1.3] flex items-center justify-center relative z-50 px-4 w-full max-w-5xl mx-auto">
                    {/* Hero content wrapper - capsules are positioned relative to this */}
                    <div className="relative w-full min-h-[280px] md:min-h-[320px] flex flex-col justify-center items-center">
                        <div className="flex flex-col justify-center items-center gap-3 md:gap-4 text-center relative z-50">
                            {/* Capsules - positioned around the central block */}
                            {capsules.map((cap, i) => {
                                const getLocalPositionClass = (pos: string) => {
                                    switch (pos) {
                                        case 'top-left': return "-top-10 left-5 sm:-left-5 sm:top-10 md:-left-5 md:-top-25 lg:-left-5 lg:-top-25 xl:-left-40 xl:-top-30  2xl:-left-65 2xl:-top-30";
                                        case 'top-right': return "-top-10 right-0 sm:-left-5 sm:top-10 md:-right-120 md:-top-25 lg:-right-180 lg:-top-25 xl:-right-240 xl:-top-30  2xl:-right-285 2xl:-top-30";
                                        case 'bottom-left': return "top-55 left-5 sm:-left-5 sm:top-10 md:-left-5 md:top-40 lg:-left-5 lg:top-50 xl:-left-40 xl:top-60  2xl:-left-65 2xl:top-50";
                                        case 'bottom-right': return "top-55 right-0 sm:-left-5 sm:top-10 md:-right-90 md:top-40 lg:-right-145 lg:top-50 xl:-right-220 xl:top-60  2xl:-right-285 2xl:top-50";
                                        default: return "";
                                    }
                                };
                                const arrowAngleClasses = ['rotate-25', 'rotate-12', 'rotate-30', 'rotate-20'];
                                const arrowRotateClass = arrowAngleClasses[i % arrowAngleClasses.length];
                                return (
                                    <div
                                        key={i}
                                        className={`absolute ${getLocalPositionClass(cap.position)} ${cap.rotate} z-10 max-w-[45%] md:max-w-none bg-none`}
                                        style={{
                                            animation: `capsuleFloat ${3 + i * 0.3}s ease-in-out infinite`,
                                            animationDelay: `${i * 0.2}s`,
                                        }}
                                    >
                                        <div
                                            className="relative z-10 inline-flex items-center justify-center overflow-visible bg-none"
                                            style={{ animation: `capsuleGlimmer ${2.8 + i * 0.3}s ease-in-out infinite` }}
                                        >

                                            <div className="relative inline-flex items-center justify-center">
                                                <span
                                                    className={`relative z-20 font-gilroy-medium text-white text-[10px] md:text-sm lg:text-sm xl:text-xl px-1 md:px-3 py-1 lg:px-8 md:py-3 rounded-full w-auto max-w-[160px] sm:max-w-[240px] md:max-w-none whitespace-normal text-center border border-white/10 ${cap.bg}`}
                                                >
                                                    {cap.text}
                                                </span>
                                            </div>
                                            <span className={`absolute -top-7 -left-1 w-5 h-5 md:w-7 md:h-7 pointer-events-none ${arrowRotateClass}`}>
                                                <CapsuleArrowHome fill={cap.arrowColor || '#FFFFFF'} />
                                            </span>
                                        </div>
                                    </div>
                                )
                            })}
                            <div className="font-rajdhani">
                                <h2 className="text-yellow font-bold text-3xl text-[35px] md:text-[50px]  lg:text-[65px]  xl:text-[70px] leading-none">
                                    Engineering Digital Excellence
                                </h2>
                            </div>

                            <div>
                                <div className="text-[#BBBBBB] font-gilroy-medium w-full text-[20px] md:text-[25px]  lg:text-[32px] xl:text-4xl mx-auto space-y-1">
                                    <p> We build enterprise-grade web applications,</p>
                                    <p> mobile experiences, and AI-powered systems that transform</p>
                                    <p> how businesses operate and compete.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative mt-10 w-full">
  <div
    className="
      w-full 
      sm:w-[80%] md:w-auto
      flex 
      flex-col 
      md:flex-row
      items-center 
      justify-center 
      gap-4 md:gap-5
      font-rajdhani
    "
  >

    {/* PRIMARY BUTTON */}
    <Button
      className="
       w-[70%]
      sm:w-[70%]
         md:w-auto
        bg-transparent 
        border-2 border-purple 
        text-white 
        p-2 px-4 md:px-8
        md:p-3 lg:px-10
        text-[16px] md:text-[18px] lg:text-[20px] xl:text-[25px]
        transition-all duration-600 ease-in
        hover:bg-purple 
        hover:text-white
      "
     onClick={handlestartyourproject}
    >
      Start Your Project
    </Button>

    {/* SECONDARY BUTTON */}
    <Button
      className="
      w-[70%]
      sm:w-[70%]
        md:w-auto
        bg-transparent 
        border-2 border-purple 
        text-white 
        p-2 px-4 md:px-8
        md:p-3 lg:px-10
        text-[16px] md:text-[18px] lg:text-[20px] xl:text-[25px]
        transition-all duration-600 ease-in
        hover:bg-purple 
        hover:text-white
      "
     onClick={handleviewOurWork}
    >
      View our Work
    </Button>

  </div>
</div>
            </div>
        </div>
    )
}

export default HomeBannerComponent 